import { UserProfile } from '../types/user';
import apiClient from './client';

export async function fetchUserProfile(): Promise<UserProfile | null> {
  try {
    const response = await apiClient.get<UserProfile>('/UserProfile/me');
    return response.data;
  } catch (err: any) {
    if (err?.response?.status === 404) return null;
    throw err;
  }
}

export async function updateUserProfile(profile: Partial<UserProfile>): Promise<UserProfile> {
  const response = await apiClient.put<UserProfile>('/UserProfile', profile);
  return response.data;
}

export async function deleteAccount(): Promise<void> {
  await apiClient.delete('/Account');
}

export async function createUserProfile(profile: Partial<UserProfile>): Promise<UserProfile> {
  const response = await apiClient.post<UserProfile>('/UserProfile', profile);
  return response.data;
}
